import { render, staticRenderFns } from "./CustomerOnboardingSuccessView.vue?vue&type=template&id=6e1f0f22&scoped=true&"
import script from "./CustomerOnboardingSuccessView.vue?vue&type=script&lang=ts&"
export * from "./CustomerOnboardingSuccessView.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOnboardingSuccessView.vue?vue&type=style&index=0&id=6e1f0f22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1f0f22",
  null
  
)

export default component.exports